/**
 * AIArenaPage Component
 *
 * Full page showing AI Portfolio Competition with performance cards,
 * historical chart, and portfolio breakdown with copy feature.
 *
 * Route: /ideas/ai-arena
 */

import { FC } from 'react';
import { css } from '@emotion/react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { spacing } from '../../styles';
import Page from '../Page';
import Header from '../Header';
import FeedbackFooter from '../FeedbackFooter';
import { PerformanceCards, PerformanceChart, PortfolioBreakdown } from '../AIArena';

const AIArenaPage: FC = () => {
  const { t } = useTranslation();
  const history = useHistory();

  return (
    <Page showNavigationBar>
      <Header headingText={t('aiarena.copyTradeHeading')} onBack={() => history.goBack()} variant="left-aligned" />

      <div
        css={css`
          max-width: 600px;
          margin: 0 auto;
          padding-top: ${spacing.centi};
        `}
      >
        {/* Performance Cards */}
        <section
          css={css`
            margin-bottom: ${spacing.hecto};
          `}
        >
          <PerformanceCards />
        </section>

        {/* Performance Chart */}
        <section
          css={css`
            margin-bottom: ${spacing.hecto};
          `}
        >
          <PerformanceChart />
        </section>

        {/* Portfolio Breakdown */}
        <section
          css={css`
            margin-bottom: ${spacing.hecto};
          `}
        >
          <PortfolioBreakdown />
        </section>

        <FeedbackFooter />
      </div>
    </Page>
  );
};

export default AIArenaPage;
